module.exports = __webpack_public_path__ + "img/shower.641cd444.png";